import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import de from './locale/de-DE.json';
import en from './locale/en-US.json';
import es from './locale/es-419.json';
import fr from './locale/fr-FR.json';
import it from './locale/it-IT.json';
import pl from './locale/pl-PL.json';
import pt from './locale/pt-BR.json';
import th from './locale/th-TH.json';
import tr from './locale/tr-TR.json';
import zh from './locale/zh-TW.json';
import nl from './locale/nl-NL.json';
import ru from './locale/ru-RU.json';

const { application } = window;

i18n.use(initReactI18next).init({
    resources: { de, en, es, fr, it, pl, pt, th, tr, zh, nl, ru },
    lng: application ? application.params.locale.split('_')[0] : 'en',
    fallbackLng: ['en', 'zh', 'th'],
    debug: process.env.NODE_ENV !== 'production',
    ns: ['common', 'settings'],
    defaultNS: 'common',
    keySeparator: '.',
    interpolation: {
        escapeValue: false,
    },
    react: {
        wait: false,
        withRef: true,
        bindI18n: 'languageChanged loaded',
        bindStore: 'added removed',
        nsMode: 'default',
        defaultTransParent: 'div',
    },
}, () => {
    const body = document.querySelector('body');
    if (!body) return;
    body.className += `lang-${application?.params?.locale || 'en-US'}`;
});

export default i18n;
